import api from '@utils/api';
import React, { useEffect, useRef, useState } from 'react';
import SwiperCore, { Autoplay, Controller, FreeMode, Keyboard, Navigation } from 'swiper';
import { Swiper as SwiperInstance, SwiperSlide } from 'swiper/react';
import { useTranslation } from 'react-i18next';
import useBreakpoint from '@utils/useBreakpoint';
import classNames from 'classnames';
import analytics from '@utils/analytics';
import customEventBus from '@common/scripts/libs/eventBus';
SwiperCore.use([Keyboard, Navigation, Autoplay, Controller]);
const StoriesCarousel = (props) => {
    const { uuid, pageId } = props;
    const { t } = useTranslation();
    const [componentCards, setComponentCards] = useState([]);
    const [currentComponent, setCurrentComponent] = useState();
    const swiperRef = useRef();
    const autoPlayBtn = useRef();
    const [beforeLoopFix, setBeforeLoopFix] = useState(false);
    const [isActive, setIsActive] = useState(false);
    const [clickedOn, setClickedOn] = useState(false);
    const [previousTranslate, setPreviousTranslate] = useState(null);
    const [isQuerying, setIsQuerying] = useState(false);
    const currentBreakpoint = useBreakpoint();
    useEffect(() => {
        api.getPageJson(pageId, true).then((data) => {
            var _a, _b, _c, _d, _e;
            const component = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.regions) === null || _a === void 0 ? void 0 : _a.find((el) => el.id === 'main')) === null || _b === void 0 ? void 0 : _b.components) === null || _c === void 0 ? void 0 : _c.find((el) => el.id === uuid);
            const componentCards = (_e = (_d = component === null || component === void 0 ? void 0 : component.regions) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.components;
            if (component)
                setCurrentComponent(component);
            if (componentCards)
                setComponentCards(componentCards);
        });
    }, []);
    useEffect(() => {
        //listener for FaqSearchInput.tsx query, after digit in input, this Swiper go to display none, when returns visible it brokes. This useEffect ricalculate Swiper after input cleanings up.
        customEventBus.on('query:update', (data) => {
            setIsQuerying(!!(data === null || data === void 0 ? void 0 : data.query));
        });
    }, []);
    const swiperConf = {
        navigation: false,
        roundLengths: true,
        slidesPerView: 1,
        spaceBetween: 2,
        speed: 600,
        autoplay: {
            pauseOnMouseEnter: true,
            disableOnInteraction: false,
            delay: 2000,
        },
        threshold: 20,
        slideToClickedSlide: true,
        centeredSlides: true,
        loop: true,
        centeredSlidesBounds: true,
        preventClicks: true,
        longSwipes: true,
        shortSwipes: true,
        preventInteractionOnTransition: true,
        // watchSlidesProgress: true,
        modules: [FreeMode, Navigation, Controller],
        freeMode: false,
        // noSwiping: true,
        breakpoints: {
            600: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 3,
            },
        },
    };
    const stopAutoplay = () => {
        var _a;
        (_a = swiperRef.current) === null || _a === void 0 ? void 0 : _a.autoplay.stop();
        swiperRef.current.params.autoplay = {
            pauseOnMouseEnter: false,
            disableOnInteraction: true,
            delay: 2000,
        };
        swiperRef.current.update();
    };
    const playAutoplay = () => {
        swiperRef.current.params.autoplay = {
            delay: 2000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
            reverseDirection: false,
            stopOnLastSlide: false,
            waitForTransition: true,
        };
        swiperRef.current.update();
        swiperRef.current.autoplay.start();
    };
    const restoreTranslate = () => {
        if (previousTranslate != null && swiperRef.current && isActive) {
            swiperRef.current.setTranslate(previousTranslate);
            setPreviousTranslate(null);
        }
    };
    const preventHorizontalScroll = (e) => {
        if (Math.abs(e.deltaX) >= Math.abs(e.deltaY)) {
            e.preventDefault();
        }
    };
    const wheelScroll = (e) => {
        if (e.deltaX >= 20) {
            restoreTranslate();
            swiperRef.current.slideNext();
        }
        else if (e.deltaX <= -20) {
            restoreTranslate();
            swiperRef.current.slidePrev();
        }
    };
    const getOpenSlideWidth = () => {
        return (window.visualViewport.width * 62.639) / 100;
    };
    if (!currentComponent || !componentCards || isQuerying) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: `stories-carousel container ${currentComponent.data.invertedColor ? 'inverted-color' : ''} ${currentComponent.data.noTimeline ? 'no-timeline' : ''}`, id: props.componentId },
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col-md-12 stories-carousel__container" },
                React.createElement("div", { className: "card-swiper-container", onWheel: (e) => {
                        wheelScroll(e);
                    } },
                    React.createElement("h2", { className: "stories-carousel__title primary-l-u" }, props.title),
                    React.createElement(SwiperInstance, Object.assign({ className: "cards-swiper" }, swiperConf, { onAutoplayStart: (swiper) => {
                            var _a;
                            (_a = autoPlayBtn.current) === null || _a === void 0 ? void 0 : _a.setAttribute('aria-pressed', 'false');
                        }, onAutoplayStop: (swiper) => {
                            var _a;
                            (_a = autoPlayBtn.current) === null || _a === void 0 ? void 0 : _a.setAttribute('aria-pressed', 'true');
                        }, onAutoplayPause: (swiper) => {
                            // if (autoPlayBtn.current?.getAttribute('aria-pressed') === 'true') {
                            //   swiper.autoplay.running = false;
                            // }
                            // autoPlayBtn.current?.setAttribute('aria-pressed', 'true');
                        }, onAutoplayResume: (swiper) => {
                            // if (autoPlayBtn.current?.getAttribute('aria-pressed') === 'true') {
                            //   swiper.autoplay.running = false;
                            // }
                            // autoPlayBtn.current?.setAttribute('aria-pressed', 'true');
                        }, onClick: (swiper, e) => {
                            if (swiper.animating || swiper.activeIndex !== swiper.clickedIndex) {
                                setClickedOn(true);
                                return;
                            }
                            if (e.target.tagName === 'A')
                                return;
                            swiper.slides[swiper.activeIndex].classList.toggle('open-slide');
                            if (isActive) {
                                restoreTranslate();
                                setIsActive(false);
                                swiper.$el[0].querySelector('.swiper-wrapper').classList.remove('isActiveState');
                            }
                            else {
                                setIsActive(true);
                                swiper.$el[0].querySelector('.swiper-wrapper').classList.add('isActiveState');
                                if (currentBreakpoint >= window.mqObj.sm) {
                                    setPreviousTranslate(swiper.translate);
                                    swiper.setTranslate(-swiper.snapGrid[swiper.snapIndex] - (getOpenSlideWidth() - swiper.slides[swiper.activeIndex].offsetWidth) / 2);
                                }
                            }
                        }, onSlidePrevTransitionStart: (swiper) => {
                            // console.log('onSlidePrevTransitionStart');
                            if (beforeLoopFix)
                                return;
                            swiper.$el[0].querySelector('.swiper-wrapper').classList.remove('isActiveState');
                        }, onSlideNextTransitionStart: (swiper) => {
                            // console.log('onSlideNextTransitionStart');
                            if (beforeLoopFix)
                                return;
                            swiper.$el[0].querySelector('.swiper-wrapper').classList.remove('isActiveState');
                        }, onBeforeTransitionStart: (swiper) => {
                            // console.log('onBeforeTransitionStart');
                            if (!beforeLoopFix)
                                return;
                            // setBeforeLoopFix(false);
                        }, onSetTranslate: (swiper) => {
                            // console.log('onSetTranslate');
                        }, onSliderFirstMove: (swiper) => {
                            // console.log('onSliderFirstMove', swiper);
                            setIsActive(false);
                            swiper.$el[0].querySelector('.swiper-wrapper').classList.remove('isActiveState');
                            setBeforeLoopFix(false);
                        }, onSlideChangeTransitionEnd: (swiper) => {
                            // console.log(swiper, 'onSlideChangeTransitionEnd');
                            if (!clickedOn)
                                return;
                            swiper.$el[0].querySelector('.swiper-wrapper').classList.add('isActiveState');
                            if (currentBreakpoint >= window.mqObj.sm) {
                                setPreviousTranslate(swiper.translate);
                                swiper.setTranslate(-swiper.snapGrid[swiper.snapIndex] - (getOpenSlideWidth() - swiper.slides[swiper.activeIndex].offsetWidth) / 2);
                            }
                            swiper.slides[swiper.activeIndex].classList.add('open-slide');
                            setIsActive(true);
                            setClickedOn(false);
                            setBeforeLoopFix(false);
                            // @ts-ignore
                        }, onSwiper: (swiper) => {
                            swiperRef.current = swiper;
                        }, onInit: (swiper) => {
                            swiper.el.addEventListener('wheel', preventHorizontalScroll);
                        }, onDestroy: (swiper) => {
                            swiper.el.removeEventListener('wheel', preventHorizontalScroll);
                        }, onBeforeLoopFix: (swiper) => {
                            // console.log('onBeforeLoopFix');
                            // console.log('isActive:', isActive);
                            if (!isActive)
                                return;
                            if (swiper.activeIndex < swiper.loopedSlides || swiper.activeIndex >= swiper.slides.length - swiper.loopedSlides) {
                                setBeforeLoopFix(true);
                                swiper.$el[0].querySelector('.swiper-wrapper').classList.remove('isActiveState');
                                let el = swiper.$el[0].querySelector(`.swiper-slide-duplicate-active`);
                                el.classList.add('noTransition');
                                el.classList.add('open-slide');
                                // el.classList.remove('noTransition');
                                let elAct = swiper.$el[0].querySelector(`.swiper-slide-active`);
                                elAct.classList.add('noTransition');
                                elAct.classList.remove('open-slide');
                                // elAct.classList.remove('noTransition');
                                setIsActive(false);
                            }
                            else {
                                let elAct = swiper.$el[0].querySelector(`.swiper-slide-active`);
                                elAct.classList.remove('open-slide');
                                //adding
                                setIsActive(false);
                            }
                        }, onBeforeSlideChangeStart: (swiper) => {
                            // console.log('onBeforeSlideChangeStart');
                        } }), componentCards.map((card, i) => {
                        return (React.createElement(SwiperSlide, { key: i, className: classNames({ 'cursor-pointer': card.data.cardLink }) },
                            React.createElement("button", { className: "stories-card", onClick: () => {
                                    if (props.pageType === 'clientservice') {
                                        analytics.clientServiceRedesignAnalytics(props.pagetitleforanalytics.toLowerCase(), (card.data.title_analytics || props.title).toLowerCase() + '-' + (card.data.card_title_analytics || card.data.title || '').toLowerCase());
                                    }
                                } },
                                React.createElement("picture", { className: "stories-card__image" },
                                    card.custom.imageM != '' && React.createElement("source", { media: "(max-width: 1023px)", srcSet: card.custom.imageM }),
                                    React.createElement("img", { src: card.custom.image, alt: "" }),
                                    " "),
                                React.createElement("div", { className: "stories-card__text-column" },
                                    React.createElement("h3", { className: "stories-card__title" }, card.data.title),
                                    React.createElement("div", { dangerouslySetInnerHTML: { __html: card.data.description } }),
                                    card.data.link && (React.createElement("div", { className: "stories-card__cta" }, card.data.link && (React.createElement("a", { href: card.data.link, className: `button button--arrow-right button--tertiary${props.invertedColor ? '' : '--inverted'}` }, card.data.linkText))))),
                                React.createElement("h3", { className: "stories-card__external-title" }, card.data.title))));
                    })),
                    React.createElement("div", { className: "stories-card__arrow-container" },
                        React.createElement("i", { className: `${currentComponent.data.invertedColor ? 'btn--backward-white' : 'btn--backward'}` }),
                        React.createElement("p", { className: "stories-card__arrow-txt primary-s" }, t('label.swipetoexplore')),
                        React.createElement("i", { className: `${currentComponent.data.invertedColor ? 'btn--forward-white' : 'btn--forward'}` }),
                        React.createElement("button", { type: "button", onClick: (e) => {
                                // swiperRef.current.autoplay.running ? swiperRef.current?.autoplay.stop() : swiperRef.current.autoplay.start();
                                if (swiperRef.current.autoplay.running) {
                                    stopAutoplay();
                                }
                                else {
                                    playAutoplay();
                                }
                            }, className: classNames('stories-carousel__btn-pause', 'btn--pause', currentComponent.data.invertedColor && 'btn--pause-white'), "aria-label": t('button.pause'), "aria-pressed": "false", ref: autoPlayBtn })))))));
};
export default StoriesCarousel;
